<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="case-container">
            <Title class="cmca" :bol="true" :list="list1" @selectType="selectType" />
        </div>
        <div v-if="$store.state.settings.mode ==='pc'" class="case-container" @mouseover="enterBanner" @mouseleave="leaveBanner">
            <div class="bannar-list">
                <swiper ref="mySwiper" class="caseSwiper" :options="bannerOption">
                    <swiper-slide v-for="(item, index) in ActivityList" :key="index">
                        <router-link :to="{name: 'PoliciesDetails',params:{xId:ActivityList[index].xId}}">
                            <div class="bannar-box">
                                <a :href="item.xUrl ? item.xUrl : 'javascript:;'">
                                    <img class="img" :src="item.imageFace" alt>
                                </a>
                            </div>
                        </router-link>
                    </swiper-slide>

                    <div slot="pagination" class="swiper-pagination" />
                </swiper>
            </div>
            <div class="type-list">
                <ul>
                    <li v-for="(item, index) in ActivityList" :key="index" :class="swiperIndex == index ? 'active right' : 'right'" @mouseover="activate(index)" @click="swiperListBtn(ActivityList[index].xId)">
                        <span class="text-type">{{ item.xName }}</span>
                        <span>{{ item.showTime }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="$store.state.settings.mode ==='pc'" class="title-container">
            <Title class="title-list" :bol="true" :list="list" @selectType="selectType" />
            <div class="title-content">
                <div v-if="newsDataList.length" class="title-left">
                    <router-link
                        :to="{name: 'PoliciesDetails',params:{xId:newsDataList[0].xId}}"
                    >
                        <div class="title-left-img">
                            <img :src="newsDataList[0].imageFace" alt="">
                        </div>
                        <div class="title-header">
                            <span>{{ newsDataList[0].xName }}</span>
                            <img src="./../assets/images/index/right.png" alt="">
                        </div>
                        <div class="title-footer">
                            <span class="title-time">
                                {{ newsDataList[0].showTime	| newsCapitalize }}
                                <i>{{ newsDataList[0].showTime | newsCapitalizes }}-{{ newsDataList[0].showTime | newsCapitalizec }}</i>
                            </span>
                            <p class="title-text">
                                {{ newsDataList[0].intro }}
                            </p>
                        </div>
                    </router-link>
                </div>
                <div class="title-right">
                    <ul>
                        <RouterLink
                            v-for="(item, index) in newsDataList.slice(1)"
                            :key="index"
                            :to="{name: 'PoliciesDetails',params:{xId:item.xId}}"
                            tag="li"
                        >
                            <div class="time-box">
                                <span class="timeNumber">{{ item.showTime | newsCapitalize }}</span>
                                <i>{{ item.showTime | newsCapitalizes }}-{{ item.showTime | newsCapitalizec }}</i>
                            </div>
                            <div class="text">
                                <h4>{{ item.xName }}</h4>
                                <p>{{ item.intro }}</p>
                            </div>
                        </RouterLink>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="$store.state.settings.mode ==='pc'" class="title-container">
            <Title class="title-list" :bol="false" :list="list2" />
            <div class="title-content">
                <div v-if="PoliciesDataList.length" class="title-left">
                    <router-link
                        :to="{name: 'PoliciesDetails',params:{xId:PoliciesDataList[0].xId}}"
                    >
                        <div class="title-left-img">
                            <img :src="PoliciesDataList[0].imageFace" alt="">
                        </div>
                        <div class="title-header">
                            <span>{{ PoliciesDataList[0].xName }}</span>
                            <img src="./../assets/images/index/right.png" alt="">
                        </div>
                        <div class="title-footer">
                            <span class="title-time">
                                {{ PoliciesDataList[0].showTime	| newsCapitalize }}
                                <i>{{ PoliciesDataList[0].showTime | newsCapitalizes }}-{{ PoliciesDataList[0].showTime | newsCapitalizec }}</i>
                            </span>
                            <p class="title-text">
                                {{ PoliciesDataList[0].intro }}
                            </p>
                        </div>
                    </router-link>
                </div>
                <div class="title-right">
                    <ul>
                        <RouterLink
                            v-for="(item, index) in PoliciesDataList.slice(1)"
                            :key="index"
                            :to="{name: 'PoliciesDetails',params:{xId:item.xId}}"
                            tag="li"
                        >
                            <div class="time-box">
                                <span class="timeNumber">{{ item.showTime | newsCapitalize }}</span>
                                <i>{{ item.showTime | newsCapitalizes }}-{{ item.showTime | newsCapitalizec }}</i>
                            </div>
                            <div class="text">
                                <h4>{{ item.xName }}</h4>
                                <p>{{ item.intro }}</p>
                            </div>
                        </RouterLink>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="$store.state.settings.mode ==='pc'" class="title-container">
            <Title class="title-list" :bol="false" :list="list3" />
            <div class="title-content">
                <div v-if="wxDataList.length" class="title-left">
                    <router-link
                        :to="{name: 'PoliciesDetails',params:{xId:wxDataList[0].xId}}"
                    >
                        <div class="title-left-img">
                            <img :src="wxDataList[0].imageFace" alt="">
                        </div>
                        <div class="title-header">
                            <span>{{ wxDataList[0].xName }}</span>
                            <img src="./../assets/images/index/right.png" alt="">
                        </div>
                        <div class="title-footer">
                            <span class="title-time">
                                {{ wxDataList[0].showTime	| newsCapitalize }}
                                <i>{{ wxDataList[0].showTime | newsCapitalizes }}-{{ wxDataList[0].showTime | newsCapitalizec }}</i>
                            </span>
                            <p class="title-text">
                                {{ wxDataList[0].intro }}
                            </p>
                        </div>
                    </router-link>
                </div>
                <div class="title-right">
                    <ul>
                        <RouterLink
                            v-for="(item, index) in wxDataList.slice(1)"
                            :key="index"
                            :to="{name: 'PoliciesDetails',params:{xId:item.xId}}"
                            tag="li"
                        >
                            <div class="time-box">
                                <span class="timeNumber">{{ item.showTime | newsCapitalize }}</span>
                                <i>{{ item.showTime | newsCapitalizes }}-{{ item.showTime | newsCapitalizec }}</i>
                            </div>
                            <div class="text">
                                <h4>{{ item.xName }}</h4>
                                <p>{{ item.intro }}</p>
                            </div>
                        </RouterLink>
                    </ul>
                </div>
            </div>
        </div>
        <!-- && false 2023/6/8 史总发的 需求调整 隐藏证件查询 -->
        <div v-if="$store.state.settings.mode ==='pc' && false" class="title-container">
            <Title class="title-list" :bol="false" :list="list4" />
            <div class="title-content">
                <div v-if="PoliciesDataList.length" class="title-left">
                    <router-link
                        :to="{name: 'PoliciesDetails',params:{xId:PoliciesDataList[0].xId}}"
                    >
                        <div class="title-left-img">
                            <img :src="PoliciesDataList[0].imageFace" alt="">
                        </div>
                        <div class="title-header">
                            <span>{{ PoliciesDataList[0].xName }}</span>
                            <img src="./../assets/images/index/right.png" alt="">
                        </div>
                        <div class="title-footer">
                            <span class="title-time">
                                {{ PoliciesDataList[0].showTime	| newsCapitalize }}
                                <i>{{ PoliciesDataList[0].showTime | newsCapitalizes }}-{{ PoliciesDataList[0].showTime | newsCapitalizec }}</i>
                            </span>
                            <p class="title-text">
                                {{ PoliciesDataList[0].intro }}
                            </p>
                        </div>
                    </router-link>
                </div>
                <div class="title-right">
                    <ul>
                        <RouterLink
                            v-for="(item, index) in PoliciesDataList.slice(1)"
                            :key="index"
                            :to="{name: 'PoliciesDetails',params:{xId:item.xId}}"
                            tag="li"
                        >
                            <div class="time-box">
                                <span class="timeNumber">{{ item.showTime | newsCapitalize }}</span>
                                <i>{{ item.showTime | newsCapitalizes }}-{{ item.showTime | newsCapitalizec }}</i>
                            </div>
                            <div class="text">
                                <h4>{{ item.xName }}</h4>
                                <p>{{ item.intro }}</p>
                            </div>
                        </RouterLink>
                    </ul>
                </div>
            </div>
        </div>
        <mobileSwiper v-if="$store.state.settings.mode ==='mobile'" />
        <mobileTab v-if="$store.state.settings.mode ==='mobile'" />
    </div>
</template>
<script>
import 'swiper/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import mobileSwiper from '@/views/compontents/home/banner.vue'
import mobileTab from '@/views/compontents/home/tab.vue'
import Title from '@/layout/title'

export default {
    components: {
        swiperSlide,
        swiper,
        mobileSwiper,
        mobileTab,
        Title
    },
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.trim().split(' ')
            return value[0]
        },
        capitalizes: function(value) {
            if (!value) return ''
            value = value.trim().split(' ')
            return value[1]
        },
        newsCapitalize: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[0]
        },
        newsCapitalizes: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[1]
        },
        newsCapitalizec: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[2]
        },
        time: function(value) {
            if (!value) return ''
            value = value.trim().split(' ')
            return value[0]
        }
    },
    data() {
        return {
            activeIndex: 0,
            imgActive: '',
            list: [
                {
                    name: '新闻中心',
                    englishName: 'News Center',
                    status: '1'
                }
            ],
            list1: [
                {
                    name: 'CMCA动态',
                    englishName: 'CMCA Dynamic',
                    status: '2'
                }
            ],
            list2: [
                {
                    name: '党建工作',
                    englishName: 'Party building',
                    status: '3'
                }
            ],
            list4: [
                {
                    name: '证件查询',
                    englishName: 'certificateInquiry',
                    status: '5'
                }
            ],
            bannerDataList: [],
            newsDataList: [],
            ActivityList: [],
            PoliciesDataList: [],
            wxDataList: [],
            list3: [
                {
                    name: '会议活动',
                    englishName: 'Conference',
                    status: '4'
                }
            ],
            titleLeft: '广电总局：微博微信等传播视听节目应取得许可证',
            swiperIndex: 0,
            bannerOption: {
                loop: false,
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 2000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, // 修改swiper的父元素时，自动初始化swiper
                activeIndex: 0,
                on: {
                    slideChangeTransitionEnd: () => {
                        this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex
                    }
                },
                swiperIndex: 0
            },
            caseOption: {
                // 案例
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                loop: false
            }
        }
    },
    computed: {
        reasonSwiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    mounted() {
        this.bannerList()
        this.newsList()
        this.ActivityData()
        this.PoliciesData()
        this.wxData()
    },
    methods: {
        getIndex(index) {
            this.swiperIndex = index
        },
        activate(index) {
            this.reasonSwiper.slideTo(index)
        },
        swiperListBtn(index) {
            this.$router.push({
                name: 'PoliciesDetails',
                params: {
                    xId: index
                }
            })
        },
        selectType(value) {
            if (value == 0) {
                this.newsList()
            } else if (value == 1) {
                this.NewsDataRequest()
            } else if (value == 2) {
                this.NewsDynamic()
            } else {
                this.NewsWhole()
            }
        },
        bannerList() {
            this.$api.get('banner/xList').then(res => {
                this.bannerDataList = res.data.list
            })
        },
        newsList() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 4,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.newsDataList = res.data.list
            })
        },
        NewsDataRequest() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 4,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.newsDataList = res.data.list
            })
        },
        NewsDynamic() {
            this.$api.get('news/xList', {
                params: {
                    cId: 3,
                    limit: 4,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.newsDataList = res.data.list
            })
        },
        ActivityData() {
            this.$api.get('news/xList', {
                params: {
                    cId: 3,
                    limit: 6,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.ActivityList = res.data.list
            })
        },
        PoliciesData() {
            this.$api.get('news/xList', {
                params: {
                    cId: 4,
                    limit: 4,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.PoliciesDataList = res.data.list

            })
        },
        wxData() {
            this.$api.get('news/xList', {
                params: {
                    cId: 5,
                    limit: 4,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.wxDataList = res.data.list
            })
        },
        NewsWhole() {
            this.$router.push({name: 'Policies', params: {cId: 1} })
        },
        enterBanner() {
            this.$refs.mySwiper.swiper.autoplay.stop()
        },
        leaveBanner() {
            this.$refs.mySwiper.swiper.autoplay.start()
        }
    }
}
</script>
<style lang="scss" scoped>
.swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /* 之前是ease-out */
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
}
a {
    text-decoration: none;
}
.swiper-slide {
    background-size: cover;
    background-position: center;
    .bannar-box-icon {
        width: 100%;
        span {
            font-size: 14px;
            font-weight: 400;
            color: white;
            line-height: 22px;
            padding: 20px 20px;
            display: block;
        }
        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
}
.gallery-top {
    height: 80% !important;
    width: 100%;
}
.gallery-thumbs {
    margin: 0;
    margin-top: 56px;
    width: 517px;
    height: 378px;
    opacity: 0.9;
    background-color: #ccc;
}
.router-link-active {     //点击时去掉下划线
    text-decoration: none;
}
.case-container {
    width: 1170px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .cmca {
        width: 100%;
        display: flex;
        margin-top: 40px;
        justify-content: space-between;
    }
    .bannar-list {
        width: 614px;
        height: 374px;
        position: relative;
        top: 0;
        .caseSwiper {
            width: 100%;
            height: 100%;
        }
        .list-type {
            width: 614px;
            height: 50px;
            position: absolute;
            bottom: 0;
            z-index: 99999;
            .swiper-pagination {
                width: 517px;
                height: 378px;
                line-height: 50px;
                position: absolute;
                right: -558px;
                top: -338px;
                padding: 0;
                border-bottom: 1px solid rgba(233, 233, 233, 1);
                ::v-deep .swiper-pagination-bullet {
                    width: 100%;
                    height: 62px;
                    line-height: 62px;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    display: flex;
                    background: #fff;
                    justify-content: space-between;
                    border-top: 1px solid #666;
                    border-radius: 0%;
                }
                ::v-deep .swiper-pagination-bullet-active {
                    height: auto;
                    color: #243db3;
                    opacity: 0.4;
                    border-top: 1px solid #999;
                    .bannar-box-icon {
                        span {
                            color: white;
                            font-size: 20px;
                            display: block;
                            line-height: 40px;
                        }
                    }
                }
            }
            .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
                width: 10px;
                height: 10px;
                border-radius: 50%;
            }
        }
        .swiper-container {
            height: 100%;
            font-size: 0;
            .bannar-box {
                background-color: #fff;
                img {
                    width: 100%;
                    height: auto;
                    display: block;
                }
            }
            .bannar-box-icon {
                width: 100%;
            }
            .swiper-slide img {
                width: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide {
                height: 80px;
                cursor: pointer;
            }
            .swiper-slide-active {
                height: auto;
                background: #243db3;
                .bannar-box-icon {
                    span {
                        color: white;
                        font-size: 20px;
                        display: block;
                        line-height: 40px;
                    }
                }
            }
        }
    }
    .type-list {
        width: 517px;
        height: 378px;
        // margin: 56px 0 0 0;
        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            li {
                cursor: pointer;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 62px;
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid rgba(233, 233, 233, 1);
                &:first-child {
                    border-top: 1px solid rgba(233, 233, 233, 1);
                }
                &:last-child {
                    border-bottom: 1px solid rgba(233, 233, 233, 1);
                }
                .text-type {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: block;
                    width: 400px;
                }
                &:hover {
                    font-size: 16px;
                    font-weight: 800;
                    color: #243db3;
                    line-height: 62px;
                }
            }
            .active {
                font-size: 16px;
                font-weight: 800;
                color: #243db3;
            }
        }
    }
    .new-list {
        z-index: 99;
    }
}
.title-container {
    width: 1170px;
    margin: 0 auto;
    .title-list {
        width: 100%;
        margin-top: 40px;
    }
    .title-content {
        display: flex;
        justify-content: space-between;
        .title-left {
            width: 614px;
            .title-left-img {
                width: 100%;
                height: 200px;
                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    z-index: 99;
                }
            }
            .title-header {
                display: flex;
                justify-content: space-between;
                span {
                    display: block;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 72px;
                }
            }
            .title-footer {
                display: flex;
                justify-content: space-between;
                padding-bottom: 20px;
                height: 60px;
                .title-time {
                    font-size: 24px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    display: block;
                    text-align: center;
                    position: relative;
                    i {
                        font-style: normal;
                        font-size: 16px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        display: block;
                        top: 0;
                        text-align: center;
                    }
                    &::after {
                        content: "";
                        margin-left: 45px;
                        border-left: 1px solid rgba(233, 233, 233, 1);
                        height: 40px;
                        display: inline-block;
                        vertical-align: middle;
                        position: absolute;
                        top: 10px;
                    }
                }
                .title-text {
                    width: 476px;
                    margin: 0;
                    line-height: 28px;
                    display: block;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    margin-right: 40px;
                }
                p {
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
        .title-right {
            ul {
                list-style: none;
                margin: 0;
                li {
                    border-top: 1px solid #ccc;
                    width: 468px;
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;
                    .time-box {
                        display: flex;
                        flex-wrap: wrap;
                        align-content: center;
                        .timeNumber {
                            display: block;
                            font-size: 24px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            width: 100%;
                            text-align: center;
                            padding-bottom: 2px;
                        }
                        i {
                            padding-top: 2px;
                            font-style: normal;
                            font-size: 16px;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            width: 100%;
                            text-align: center;
                        }
                    }
                    .text {
                        width: 80%;
                        h4 {
                            font-size: 20px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                            line-height: 20px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            margin-bottom: 10px;
                            margin-top: 16px;
                        }
                        p {
                            font-size: 16px;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            line-height: 24px;
                            margin-bottom: 16px;
                            margin-top: 0;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                    &:last-child {
                        border-bottom: 1px solid #ccc;
                    }
                }
            }
        }
    }
    .activityBox {
        display: flex;
        justify-content: space-between;
    }
    .title-news-center {
        display: flex;
        justify-content: space-between;
    }
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    width: 40px;
    height: 40px;
}
</style>
